import styled from 'styled-components';
import { Typography } from '../../../assets/styles/StyleTypes';

export const Content = styled.div`
  width: 100%;
  min-height: 100px;
`;

export const Paragraph = styled.p`
  text-align: center;
  ${Typography.BODY_XS}
  color: ${(props) => props.theme.colors.textPrimary};
  margin-bottom: 10px;
`;
